import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from 'common/consts/kentico';

class ServiceService {
  async fetchServices() {
    return Client.items()
      .type(KENTICO_TYPES.SERVICE)
      .toPromise();
  }
}

export default new ServiceService();



// WEBPACK FOOTER //
// ./src/services/Service.service.js